import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import { useDispatch, useSelector } from 'react-redux'
import {
    obtenerSolicitudesEntregas, obtenerDetalleFC_09, obtenerDetalleFC_33,
    obtenerDetalleFC_41, generarReciboHolograma, obtenerSolicitudesEntregasCompletadas
} from '../../../redux/DuckPanelHologramas/ModuloEntregasDuck';
import React, { Fragment, useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import BotonDescargarArchivosComponent from './BotonDescargarArchivosComponent';
import { Tab, Tabs } from '@mui/material';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

const PanelEntregasComponent = (props) => {

    const dispatch = useDispatch()

    const solicitudesentregas = useSelector(store => store.ModuloEntregas.data)
    const solicitudesentregasCompletadas = useSelector(store => store.ModuloEntregas.dataCompletadas)

    React.useEffect(async () => {
        await dispatch(obtenerSolicitudesEntregas())
        await dispatch(obtenerSolicitudesEntregasCompletadas())
    }, [])

    const columns = [
        {
            field: 'numSolicitud', headerName: 'Núm. solicitud', headerAlign: 'center', width: 150,
            renderCell: (params) =>
                params.row.isEntrega ? <div style={{
                    borderInlineStart: "2px solid red", borderTop: "2px solid red",
                    borderBottom: "2px solid red", width: '110%', height: '100%', marginRight: '2%', background: '#FF7575'
                }}>{params.row.numSolicitud}</div> : <div >{params.row.numSolicitud}</div>

        },
        {
            field: 'numAsociado', headerName: 'Núm. de asociado', headerAlign: 'center', width: 170,
            renderCell: (params) =>
                params.row.isEntrega ? <div style={{
                    borderTop: "2px solid red", borderBottom: "2px solid red",
                    width: '120%', height: '100%', marginLeft: '-8%', background: '#FF7575'
                }}>{params.row.numAsociado}</div> :
                    <div >{params.row.numAsociado}</div>
        },
        {
            field: 'fecha', headerName: 'Fecha', headerAlign: 'center', width: 150,
            renderCell: (params) =>
                params.row.isEntrega ? <div style={{
                    borderTop: "2px solid red", borderBottom: "2px solid red",
                    width: '120%', height: '100%', marginLeft: '-8%', background: '#FF7575'
                }}>{params.row.fecha}</div> :
                    <div >{params.row.fecha}</div>
        },
        {
            field: 'razonSocial', headerName: 'Razón social', headerAlign: 'center', width: 400,
            renderCell: (params) =>
                params.row.isEntrega ? <div style={{
                    borderTop: "2px solid red", borderBottom: "2px solid red",
                    width: '120%', height: '100%', marginLeft: '-8%', background: '#FF7575'
                }}>{params.row.razonSocial}</div> :
                    <div >{params.row.razonSocial}</div>
        },
        {
            field: 'producto', headerName: 'Producto', headerAlign: 'center', width: 208,
            renderCell: (params) =>
                params.row.isEntrega ? <div style={{
                    borderTop: "2px solid red", borderBottom: "2px solid red",
                    width: '120%', height: '100%', marginLeft: '-8%', background: '#FF7575'
                }}>{params.row.producto}</div> :
                    <div >{params.row.producto}</div>
        },
        {
            field: 'estatus', headerName: 'Estatus', headerAlign: 'center', width: 100,
            renderCell: (params) =>
                params.row.isEntrega ? <div style={{
                    borderTop: "2px solid red", borderBottom: "2px solid red",
                    width: '130%', height: '100%', marginLeft: '-12%', background: '#FF7575'
                }}>{params.row.estatus}</div> :
                    <div >{params.row.estatus}</div>
        },
        {
            field: 'accion', headerName: 'Acción', headerAlign: 'center', width: 180,
            renderCell: (params) =>
                params.row.isEntrega ? <div style={{
                    borderTop: "2px solid red", borderBottom: "2px solid red", borderRight: "2px solid red",
                    width: '125%', height: '100%', marginLeft: '-12%', background: '#FF7575'
                }}>
                    {params.row.isInvetario && <button className={`btn btn-outline-success`} onClick={() => detalleSolicitud(params.row)}>Revisar</button>}
                    {params.row.estatus == 'Parcial' && <BotonDescargarArchivosComponent entregashologramas={params.row.entregashologramas} />}
                </div> :
                    <div >
                        {params.row.isInvetario && <button className={`btn btn-outline-success`} onClick={() => detalleSolicitud(params.row)}>Revisar</button>}
                        {params.row.estatus == 'Parcial' && <BotonDescargarArchivosComponent entregashologramas={params.row.entregashologramas} />}
                    </div>


        },
    ]
    const columnsCompletadas = [
        {
            field: 'numSolicitud', headerName: 'Núm. solicitud', headerAlign: 'center', width: 150,
            renderCell: (params) =>
                params.row.isEntrega ? <div>{params.row.numSolicitud}</div> : <div >{params.row.numSolicitud}</div>

        },
        {
            field: 'numAsociado', headerName: 'Núm. de asociado', headerAlign: 'center', width: 170,
            renderCell: (params) =>
                params.row.isEntrega ? <div>{params.row.numAsociado}</div> :
                    <div >{params.row.numAsociado}</div>
        },
        {
            field: 'fecha', headerName: 'Fecha', headerAlign: 'center', width: 150,
            renderCell: (params) =>
                params.row.isEntrega ? <div>{params.row.fecha}</div> :
                    <div >{params.row.fecha}</div>
        },
        {
            field: 'razonSocial', headerName: 'Razón social', headerAlign: 'center', width: 400,
            renderCell: (params) =>
                params.row.isEntrega ? <div>{params.row.razonSocial}</div> :
                    <div >{params.row.razonSocial}</div>
        },
        {
            field: 'producto', headerName: 'Producto', headerAlign: 'center', width: 208,
            renderCell: (params) =>
                params.row.isEntrega ? <div >{params.row.producto}</div> :
                    <div >{params.row.producto}</div>
        },
        {
            field: 'estatus', headerName: 'Estatus', headerAlign: 'center', width: 100,
            renderCell: (params) =>
                params.row.isEntrega ? <div>{params.row.estatus}</div> :
                    <div >{params.row.estatus}</div>
        },
        {
            field: 'accion', headerName: 'Acción', headerAlign: 'center', width: 100,
            renderCell: (params) =>
                <BotonDescargarArchivosComponent entregashologramas={params.row.entregashologramas} />
        },
    ]
    const rows = []
    solicitudesentregas?.fc_09_solicitudemicioncertificadonomexportacionyentregahologram?.map(anexo => {
        let inventario = false
        let sumaBotella = 0
        for (const i in anexo.fc_09_anexoproducto) {
            sumaBotella += anexo?.fc_09_anexoproducto?.[i]?.numerobotellas
        }

        let isInvetario = false
        let isEntrega = false
        if (anexo?.login?.cliente?.[0]?.inventarioclientehologramas.length > 0) {
            isInvetario = true
            let inventarioMezcal = 0
            if (anexo?.login?.cliente?.[0]?.inventarioclientehologramas?.[0]?.hologramasmezcal == '' ||
                anexo?.login?.cliente?.[0]?.inventarioclientehologramas?.[0]?.hologramasmezcal == '0') inventarioMezcal = 0
            else inventarioMezcal = Number(anexo?.login?.cliente?.[0]?.inventarioclientehologramas?.[0]?.hologramasmezcal)
            if (sumaBotella > inventarioMezcal) isEntrega = true
        } else {
            isInvetario = false
            isEntrega = true
        }
        let estatus = ''
        if (anexo?.informacionentregahologramas?.length == 0) estatus = 'Por Atender'
        else {
            if (anexo?.informacionentregahologramas?.[0]?.idestatusentrega == 1) estatus = 'Parcial'
            else estatus = 'completado'
        }

        rows.push({
            id: uuidv4(), numSolicitud: anexo?.informacionmodalaceptada != null ? anexo?.informacionmodalaceptada?.numerosolicitudservicios : '',
            numAsociado: anexo?.numerocliente,
            fecha: anexo?.fechasolicitud?.substring(0, 10), razonSocial: anexo?.nombrecliente,
            producto: 'Exportación', isInvetario: isInvetario, isEntrega: isEntrega, tipoSolicitud: 'FC_09',
            idSolicitud: anexo.idfc09_solicitudcertificado, estatus: estatus,
            entregashologramas: anexo?.informacionentregahologramas?.length > 0 ? anexo?.informacionentregahologramas?.[0]?.entregashologramas : []
        })
    })

    solicitudesentregas?.fc_33_solicitudenvasadonacional?.map(anexo => {
        let inventario = false
        let sumaBotella = 0
        for (const i in anexo.fc_33_anexoproducto) {
            sumaBotella += Number(anexo?.fc_33_anexoproducto?.[i]?.numerobotellas)
        }
        let isInvetario = false
        let isEntrega = false
        if (anexo?.login?.cliente?.[0]?.inventarioclientehologramas.length > 0) {
            isInvetario = true
            let inventarioMezcal = 0
            if (anexo?.login?.cliente?.[0]?.inventarioclientehologramas?.[0]?.hologramasmezcal == '' ||
                anexo?.login?.cliente?.[0]?.inventarioclientehologramas?.[0]?.hologramasmezcal == '0') inventarioMezcal = 0
            else inventarioMezcal = Number(anexo?.login?.cliente?.[0]?.inventarioclientehologramas?.[0]?.hologramasmezcal)
            if (sumaBotella > inventarioMezcal) isEntrega = true
        }
        else {
            isInvetario = false
            isEntrega = true
        }
        let estatus = ''
        if (anexo?.informacionentregahologramas?.length == 0) estatus = 'Por Atender'
        else {
            if (anexo?.informacionentregahologramas?.[0]?.idestatusentrega == 1) estatus = 'Parcial'
            else estatus = 'completado'
        }
        rows.push({
            id: uuidv4(), numSolicitud: anexo?.informacionmodalaceptada != null ? anexo?.informacionmodalaceptada?.numerosolicitudservicios : '', numAsociado: anexo?.numerocliente,
            fecha: anexo?.fechasolicitud?.substring(0, 10), razonSocial: anexo?.nombrecliente,
            producto: 'Nacional', isInvetario: isInvetario, isEntrega: isEntrega, tipoSolicitud: 'FC_33',
            idSolicitud: anexo.idfc33_solicitudenvasadonaciona, estatus: estatus,
            entregashologramas: anexo?.informacionentregahologramas?.length > 0 ? anexo?.informacionentregahologramas?.[0]?.entregashologramas : []
        })
    })

    solicitudesentregas?.fc_41_solicitudparabebidasconmezcal?.map(anexo => {
        let isInvetario = false
        let isEntrega = false
        let sumaBotella = 0
        for (const i in anexo.fc_41_anexoproducto) {
            sumaBotella += Number(anexo?.fc_41_anexoproducto?.[i]?.numerobotellas)
        }
        if (anexo?.login?.cliente?.[0]?.inventarioclientehologramas.length > 0) {
            isInvetario = true
            let inventarioBebidasMezcal = 0
            if (anexo?.login?.cliente?.[0]?.inventarioclientehologramas?.[0]?.hologramasbebidas == '' ||
                anexo?.login?.cliente?.[0]?.inventarioclientehologramas?.[0]?.hologramasbebidas == '0') inventarioBebidasMezcal = 0
            else inventarioBebidasMezcal = Number(anexo?.login?.cliente?.[0]?.inventarioclientehologramas?.[0]?.hologramasbebidas)
            if (sumaBotella > inventarioBebidasMezcal) isEntrega = true
        } else {
            isInvetario = false
            isEntrega = true
        }
        let estatus = ''
        if (anexo?.informacionentregahologramas?.length == 0) estatus = 'Por Atender'
        else {
            if (anexo?.informacionentregahologramas?.[0]?.idestatusentrega == 1) estatus = 'Parcial'
            else estatus = 'completado'
        }
        rows.push({
            id: uuidv4(), numSolicitud: anexo?.informacionmodalaceptada != null ? anexo?.informacionmodalaceptada?.numerosolicitudservicios : '', numAsociado: anexo?.numerocliente,
            fecha: anexo?.fechasolicitud?.substring(0, 10), razonSocial: anexo?.nombrerazonsocial,
            producto: 'Bebidas con Mezcal', isInvetario: isInvetario, isEntrega: isEntrega, tipoSolicitud: 'FC_41',
            idSolicitud: anexo.idfc41_solicitudparabebidasconm, estatus: estatus,
            entregashologramas: anexo?.informacionentregahologramas?.length > 0 ? anexo?.informacionentregahologramas?.[0]?.entregashologramas : []
        })
    })

    const rowsCompletadas = []
    solicitudesentregasCompletadas?.fc_09_solicitudemicioncertificadonomexportacionyentregahologram?.map(anexo => {
        let inventario = false
        let sumaBotella = 0
        for (const i in anexo.fc_09_anexoproducto) {
            sumaBotella += anexo?.fc_09_anexoproducto?.[i]?.numerobotellas
        }

        let isInvetario = false
        let isEntrega = false
        if (anexo?.login?.cliente?.[0]?.inventarioclientehologramas.length > 0) {
            isInvetario = true
            let inventarioMezcal = 0
            if (anexo?.login?.cliente?.[0]?.inventarioclientehologramas?.[0]?.hologramasmezcal == '' ||
                anexo?.login?.cliente?.[0]?.inventarioclientehologramas?.[0]?.hologramasmezcal == '0') inventarioMezcal = 0
            else inventarioMezcal = Number(anexo?.login?.cliente?.[0]?.inventarioclientehologramas?.[0]?.hologramasmezcal)
            if (sumaBotella > inventarioMezcal) isEntrega = true
        } else {
            isInvetario = false
            isEntrega = true
        }
        let estatus = ''
        if (anexo?.informacionentregahologramas?.length == 0) estatus = 'Por Atender'
        else {
            if (anexo?.informacionentregahologramas?.[0]?.idestatusentrega == 1) estatus = 'Parcial'
            else estatus = 'completado'
        }

        rowsCompletadas.push({
            id: uuidv4(), numSolicitud: anexo?.informacionmodalaceptada != null ? anexo?.informacionmodalaceptada?.numerosolicitudservicios : '',
            numAsociado: anexo?.numerocliente,
            fecha: anexo?.fechasolicitud?.substring(0, 10), razonSocial: anexo?.nombrecliente,
            producto: 'Exportación', isInvetario: isInvetario, isEntrega: isEntrega, tipoSolicitud: 'FC_09',
            idSolicitud: anexo.idfc09_solicitudcertificado, estatus: estatus,
            entregashologramas: anexo?.informacionentregahologramas?.length > 0 ? anexo?.informacionentregahologramas?.[0]?.entregashologramas : []
        })
    })

    solicitudesentregasCompletadas?.fc_33_solicitudenvasadonacional?.map(anexo => {
        let inventario = false
        let sumaBotella = 0
        for (const i in anexo.fc_33_anexoproducto) {
            sumaBotella += Number(anexo?.fc_33_anexoproducto?.[i]?.numerobotellas)
        }
        let isInvetario = false
        let isEntrega = false
        if (anexo?.login?.cliente?.[0]?.inventarioclientehologramas.length > 0) {
            isInvetario = true
            let inventarioMezcal = 0
            if (anexo?.login?.cliente?.[0]?.inventarioclientehologramas?.[0]?.hologramasmezcal == '' ||
                anexo?.login?.cliente?.[0]?.inventarioclientehologramas?.[0]?.hologramasmezcal == '0') inventarioMezcal = 0
            else inventarioMezcal = Number(anexo?.login?.cliente?.[0]?.inventarioclientehologramas?.[0]?.hologramasmezcal)
            if (sumaBotella > inventarioMezcal) isEntrega = true
        }
        else {
            isInvetario = false
            isEntrega = true
        }
        let estatus = ''
        if (anexo?.informacionentregahologramas?.length == 0) estatus = 'Por Atender'
        else {
            if (anexo?.informacionentregahologramas?.[0]?.idestatusentrega == 1) estatus = 'Parcial'
            else estatus = 'completado'
        }
        rowsCompletadas.push({
            id: uuidv4(), numSolicitud: anexo?.informacionmodalaceptada != null ? anexo?.informacionmodalaceptada?.numerosolicitudservicios : '', numAsociado: anexo?.numerocliente,
            fecha: anexo?.fechasolicitud?.substring(0, 10), razonSocial: anexo?.nombrecliente,
            producto: 'Nacional', isInvetario: isInvetario, isEntrega: isEntrega, tipoSolicitud: 'FC_33',
            idSolicitud: anexo.idfc33_solicitudenvasadonaciona, estatus: estatus,
            entregashologramas: anexo?.informacionentregahologramas?.length > 0 ? anexo?.informacionentregahologramas?.[0]?.entregashologramas : []
        })
    })

    solicitudesentregasCompletadas?.fc_41_solicitudparabebidasconmezcal?.map(anexo => {
        let isInvetario = false
        let isEntrega = false
        let sumaBotella = 0
        for (const i in anexo.fc_41_anexoproducto) {
            sumaBotella += Number(anexo?.fc_41_anexoproducto?.[i]?.numerobotellas)
        }
        if (anexo?.login?.cliente?.[0]?.inventarioclientehologramas.length > 0) {
            isInvetario = true
            let inventarioBebidasMezcal = 0
            if (anexo?.login?.cliente?.[0]?.inventarioclientehologramas?.[0]?.hologramasbebidas == '' ||
                anexo?.login?.cliente?.[0]?.inventarioclientehologramas?.[0]?.hologramasbebidas == '0') inventarioBebidasMezcal = 0
            else inventarioBebidasMezcal = Number(anexo?.login?.cliente?.[0]?.inventarioclientehologramas?.[0]?.hologramasbebidas)
            if (sumaBotella > inventarioBebidasMezcal) isEntrega = true
        } else {
            isInvetario = false
            isEntrega = true
        }
        let estatus = ''
        if (anexo?.informacionentregahologramas?.length == 0) estatus = 'Por Atender'
        else {
            if (anexo?.informacionentregahologramas?.[0]?.idestatusentrega == 1) estatus = 'Parcial'
            else estatus = 'completado'
        }
        rowsCompletadas.push({
            id: uuidv4(), numSolicitud: anexo?.informacionmodalaceptada != null ? anexo?.informacionmodalaceptada?.numerosolicitudservicios : '', numAsociado: anexo?.numerocliente,
            fecha: anexo?.fechasolicitud?.substring(0, 10), razonSocial: anexo?.nombrerazonsocial,
            producto: 'Bebidas con Mezcal', isInvetario: isInvetario, isEntrega: isEntrega, tipoSolicitud: 'FC_41',
            idSolicitud: anexo.idfc41_solicitudparabebidasconm, estatus: estatus,
            entregashologramas: anexo?.informacionentregahologramas?.length > 0 ? anexo?.informacionentregahologramas?.[0]?.entregashologramas : []
        })
    })


    const detalleSolicitud = async (params) => {
        if (params.tipoSolicitud == 'FC_09') await dispatch(obtenerDetalleFC_09(params.idSolicitud))
        if (params.tipoSolicitud == 'FC_33') await dispatch(obtenerDetalleFC_33(params.idSolicitud))
        if (params.tipoSolicitud == 'FC_41') await dispatch(obtenerDetalleFC_41(params.idSolicitud))
        let data = {}
        //await dispatch(generarReciboHolograma(data))
        props.history.push('/DetalleDeEntregaComponent')
    }

    function QuickSearchToolbar() {
        return (
            <Box
                sx={{
                    p: 0.5,
                    pb: 0,
                    mb: 2,
                    textAlign: 'left',
                    height: 30,
                    width: '100%',
                    backgroundColor: 'white'
                }}>
                <GridToolbarQuickFilter style={{ backgroundColor: '#F8F9F9', width: '100%' }} placeholder='Búsqueda...' />
            </Box>
        );
    }
    const [value, setValue] = React.useState("1");
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div className="container">
            <Box className='text-center mt-5'>
                <TabContext value={value}>
                    <Box sx={{
                        borderBottom: 1, borderColor: 'divider', backgroundColor: '#4399A4', borderRadius: '2rem',
                        marginLeft: '25%', width: '55%' }} className='center'>
                        <TabList onChange={handleChange} aria-label="lab API tabs example" centered
                            sx={{
                                "& button": { color: 'white', width: '80%', borderRadius: '2rem' },
                                "& button:hover": { color: 'black', transform: 'scale(1.1)', borderRadius: '2rem' },
                                "& button.Mui-selected": {
                                    backgroundColor: 'green', color: 'white', borderRadius: '2rem', width: '80%', transform: 'scale(1.1)',
                                    fontSize: '15pt'
                                },
                            }}>
                            <Tab label="Pendientes" value="1" />
                            <Tab label="Completadas" value="2" />
                        </TabList>
                    </Box>
                    <TabPanel value="1">
                        <Box sx={{ height: 700, width: '107%', }}>
                            <DataGrid
                                rows={rows}
                                columns={columns}
                                disableColumnMenu={true}
                                initialState={{ sorting: { sortModel: [{ field: 'fecha', sort: 'desc' }], }, }}
                                components={{ Toolbar: QuickSearchToolbar }}
                                //rowsPerPageOptions={[]}
                                pageSize={10}
                                sx={{
                                    boxShadow: 0,
                                    color: 'black',
                                    border: 0,
                                    backgroundColor: 'white',
                                    '& .MuiDataGrid-cell': {
                                        display: 'block',
                                        position: 'relative',
                                        textAlign: 'center',
                                    },
                                    '& .MuiDataGrid-columnHeaders': {
                                        backgroundColor: '#4399A4',
                                        color: 'white',
                                        fontFamily: 'Montserrat',
                                        fontWeight: 'bold',
                                        height: '20px'
                                    }
                                }}
                            />
                        </Box>
                    </TabPanel>
                    <TabPanel value="2" >
                        <Box sx={{ height: 700, width: '102%', }}>
                            <DataGrid
                                rows={rowsCompletadas}
                                initialState={{ sorting: { sortModel: [{ field: 'fecha', sort: 'desc' }], }, }}
                                columns={columnsCompletadas}
                                disableColumnMenu={true}
                                components={{ Toolbar: QuickSearchToolbar }}
                                rowsPerPageOptions={[]}
                                pageSize={10}
                                sx={{
                                    boxShadow: 0,
                                    color: 'black',
                                    border: 0,
                                    backgroundColor: 'white',
                                    '& .MuiDataGrid-cell': {
                                        display: 'block',
                                        position: 'relative',
                                        textAlign: 'center',
                                    },
                                    '& .MuiDataGrid-columnHeaders': {
                                        backgroundColor: '#4399A4',
                                        color: 'white',
                                        fontFamily: 'Montserrat',
                                        fontWeight: 'bold',
                                        height: '20px'
                                    }
                                }}
                            />
                        </Box>
                    </TabPanel>
                </TabContext>
            </Box>
        </div>
    );

};
export default PanelEntregasComponent